import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import Input from '../utils/Input';
import { fetchArticleExpenditures, updateArticleExpenditures, setArticleExpendituresEdit } from '../../action/handbook';
import cn from 'classnames';
import Loader from '../utils/Loader';
import ErrorContainer from '../utils/ErrorContainer';
import { setUIvisible } from '../../action/UImobile';
import Select from 'react-select';
import { optionsTransaction } from '../../constants/app';

const styles = {
    loading: {
        minHeight: '500px',
        display: 'flex',
        justifyContent: 'center'
    }
}

class EditArticleExpenditures extends Component {
    componentWillUnmount() {
        this.props.setArticleExpendituresEdit(null);
    }

    componentDidMount() {
        this.props.fetchArticleExpenditures(this.props.match.params.id).then(article => {
            this.props.setArticleExpendituresEdit(article);
        });
        this.props.setUIvisible(false, false);
    }
    
    renderSubHeader() {
        return (
            <div className="kt-subheader not-mt kt-grid__item">
                <div className="kt-container  kt-container--fluid">
                <div className="kt-subheader__main">
                    <h3 className="kt-subheader__title">{this.props.edit.name ? this.props.edit.name : 'Введите название статьи *'}</h3>
                    <span className="kt-subheader__separator kt-subheader__separator--v"></span>
                </div>        
                <div className="kt-subheader__toolbar">
                    <button onClick={() => this.props.history.push('/handbook/articlesExpenditures')} className="btn btn-default btn-bold">
                        Назад
                    </button>
                </div>
            </div>
            </div>
        );
    }

    isValidArticleExpenditures() {
        const { name, typeTransaction } = this.props.edit;
        if (name && typeTransaction) return true;
        
        return false;
    }

    setArticleExpenditures = (field) => (e) => {
            const data = {...this.props.edit};
            if(field === 'name') {
                data[field] = e.target.value;
            } else {
                data[field] = e.value;
            }

            this.props.setArticleExpendituresEdit(data);
        }

    onSubmit = (e) => {
        e.preventDefault();
        const edited = { ...this.props.edit };
        this.props.updateArticleExpenditures(this.props.match.params.id, edited).then(result => {
            if (result) {
                this.props.history.push('/handbook/articlesExpenditures');
            }
        });        
    }

    render() {
        const { loading, edit } = this.props;
        if (loading || !edit) {
            return (
                <div style={styles.loading}><Loader/></div>
            );
        }

        return (
            <Fragment>
                { this.renderSubHeader() }
                <div className="kt-container kt-container--fluid  kt-grid__item kt-grid__item--fluid">
                <form onSubmit={this.onSubmit} className="kt-form">
                    <div className="kt-portlet">
                        <div className="kt-portlet__body">
                            <div className="row">
                                <div className="col-md-6">
                                    <Input
                                        label="Название"
                                        required={true}
                                        onChange={this.setArticleExpenditures('name')}
                                        value={edit.name}
                                        placeholder="Название..."
                                    />
                                </div>
                                <div className="col-md-6">
                                    <label>{"Тип транзакции *"}</label>
                                    <Select
                                        closeMenuOnSelect={true}
                                        value={optionsTransaction.find((option) => option.value === edit.typeTransaction)}
                                        onChange={this.setArticleExpenditures('typeTransaction')}
                                        placeholder="Тип транзакции"
                                        options={optionsTransaction}
                                        noOptionsMessage={() => 'Нет типов'}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="kt-portlet">
                        <ErrorContainer field="editArticleExpenditures" style={{ margin: '0 20px 20px' }} hasCloseButton={true}/>
                        <div className="kt-portlet__foot">
                            <div className="kt-form__actions">
                                <button
                                    disabled={!this.isValidArticleExpenditures() || this.props.loading}
                                    type="submit"
                                    className={cn({ 'btn btn-brand  kt-spinner--right kt-spinner--sm kt-spinner--light': true, 'kt-spinner': this.props.editArticleExpendituresLoader })}>
                                    Сохранить
                                </button>
                            </div>
                        </div>                    
                    </div>
                </form>
                </div>
            </Fragment>
        );
    }
}

const mapStateToProps = state => ({
    edit: state.handbook.articleExpenditures.edit,
    loading: state.loaders.articleExpenditures,
    editArticleExpendituresLoader: state.loaders.editArticleExpenditures
});

const mapDispatchToProps = {
    setArticleExpendituresEdit: (data) => setArticleExpendituresEdit(data),
    fetchArticleExpenditures: (id) => fetchArticleExpenditures(id),
    updateArticleExpenditures: (id, data) => updateArticleExpenditures(id, data),
    setUIvisible: (visibleFiltersButton, visibleActionButton) => setUIvisible(visibleFiltersButton, visibleActionButton)
}

export default connect(mapStateToProps, mapDispatchToProps)(EditArticleExpenditures);